import React from 'react';

import Icon from '../Icon/Icon';

const ConfirmationIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path d='M9.6 9.6h44.8v44.8H9.6z' />
                <path
                    d='M43.119 12.934A21.948 21.948 0 0 0 31.95 9.9C19.772 9.9 9.9 19.772 9.9 31.95S19.772 54 31.95 54 54 44.128 54 31.95'
                    stroke='#34303D'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                />
                <path
                    d='M41.193 16.483A17.966 17.966 0 0 0 32.05 14C22.081 14 14 22.081 14 32.05c0 9.969 8.081 18.05 18.05 18.05 9.969 0 18.05-8.081 18.05-18.05'
                    stroke='#00D1D2'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                />
                <path
                    stroke='#34303D'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m21.215 30.137 8.915 9.33 22.61-23.23'
                />
            </g>
        </Icon>
    );
};

export default ConfirmationIcon;
